// disable no-shadow error for stores
/* eslint-disable no-shadow, no-param-reassign */
import Vue from 'vue';
import { getRoutePathWithHash } from '@/functions/routeUtils';

export default {
  namespaced: true,
  state: () => ({}),
  getters: {
    getQuery: state => route => {
      const v = state[getRoutePathWithHash(route)];
      return v ? JSON.parse(JSON.stringify(v)) : v; // create clone if not null
    },
  },
  mutations: {
    query(state, payload) {
      // Remove trailing '/' from URL
      let key = payload?.key?.endsWith('/') ? payload?.key?.slice(0, -1) : payload?.key;
      Vue.set(state, key, payload.value);
    },
  },
  actions: {
    setQuery({ commit }, route) {
      const { query } = route;

      const payload = {
        key: getRoutePathWithHash(route),
        value: query,
      };
      commit('query', payload);
    },
    removeQuery({ commit }, route) {
      const payload = {
        key: route.name || route.path,
        value: null,
      };
      commit('query', payload);
    },
  },
};
